import { useMMGRSettings } from '../../../hoc/withMMGRSettings';

export const useStorageQuotaExperiment = (): {
  isStorageQuotaVisibilityEnabled: boolean;
  isStorageQuotaEnforcementEnabled: boolean;
} => {
  const { storageQuotaVisibilityAndEnforcementExperiment, metaSiteToken } = useMMGRSettings().mmgrSettings;

  if (storageQuotaVisibilityAndEnforcementExperiment === 'enforcement') {
    return {
      isStorageQuotaVisibilityEnabled: Boolean(metaSiteToken),
      isStorageQuotaEnforcementEnabled: true,
    };
  }

  return {
    isStorageQuotaVisibilityEnabled: false,
    isStorageQuotaEnforcementEnabled: false,
  };
};
